export const personalCoffees = [
  {
    "id": 1,
    "roaster": "Happy Coffee",
    "description": "Sidamo Espresso",
    "favorite": false,
    "grinded": false,
    "grindingTime": "7",
    "grindingDegree": "7",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2019-03-21T13:47:03.000Z"),
    "cremaRating": 5,
    "tasteRating": 4,
    "comment": "Als Espresso sehr gut und stark.",
    "origin": "ET",
    "roastLevel": "medium-dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "24.90",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 2,
    "roaster": "Dallmayr",
    "description": "d'Oro Intensa",
    "favorite": false,
    "grinded": false,
    "grindingTime": "3",
    "grindingDegree": "3",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2019-04-10T12:04:36.000Z"),
    "cremaRating": 5,
    "tasteRating": 4,
    "comment": "sehr stark",
    "origin": "",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "15.49",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 3,
    "roaster": "Dallmayr",
    "description": "Caffe Crema Perfetto",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "7",
    "percentArabica": 70,
    "percentRobusta": 30,
    "cuppingTime": new Date("2019-05-29T12:30:01.000Z"),
    "cremaRating": 0,
    "tasteRating": 0,
    "comment": "",
    "origin": "",
    "roastLevel": "medium",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "18.48",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 4,
    "roaster": "Dallmayr",
    "description": "Espresso intenso",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "7",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2019-05-29T12:32:33.000Z"),
    "cremaRating": 5,
    "tasteRating": 4,
    "comment": "erdig",
    "origin": "",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "18.99",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 6,
    "roaster": "Hrovat",
    "description": "Kaiserbohne",
    "favorite": false,
    "grinded": false,
    "grindingTime": "3",
    "grindingDegree": "3",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2019-11-19T13:00:10.000Z"),
    "cremaRating": 3,
    "tasteRating": 3,
    "comment": "",
    "origin": "AT",
    "roastLevel": "medium",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "32.00",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 7,
    "roaster": "Hrovat",
    "description": "Bürobohne",
    "favorite": false,
    "grinded": false,
    "grindingTime": "3",
    "grindingDegree": "3",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2019-11-25T13:57:16.000Z"),
    "cremaRating": 3,
    "tasteRating": 3,
    "comment": "etwas säuerlich",
    "origin": "AT",
    "roastLevel": "medium",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "28.00",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 8,
    "roaster": "220 Grad",
    "description": "Selektion Eins",
    "favorite": false,
    "grinded": false,
    "grindingTime": "2,8",
    "grindingDegree": "3",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2020-05-12T11:08:43.000Z"),
    "cremaRating": 3,
    "tasteRating": 3,
    "tasteNotes": "",
    "url": "https://www.220grad.com",
    "comment": "",
    "origin": "",
    "roastLevel": "medium",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "39.20",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 9,
    "roaster": "220 Grad",
    "description": "Guatemala La Labor",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "15",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2020-07-11T16:02:56.000Z"),
    "cremaRating": 4,
    "tasteRating": 4,
    "tasteNotes": "almonds, pecans, dried fruits, milk chocolate, lively acidity",
    "url": "https://www.220grad.com",
    "comment": "Red Bourbon variety, Finca La Labor, 1520m altitude",
    "origin": "GT",
    "roastLevel": "medium",
    "brewingMethod": "espresso",
    "recommendedMethod": "v60",
    "price": "38.30",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 10,
    "roaster": "Hrovat",
    "description": "Hallstattbohne",
    "favorite": false,
    "grinded": false,
    "grindingTime": "3",
    "grindingDegree": "7",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2020-12-15T07:38:09.000Z"),
    "cremaRating": 3,
    "tasteRating": 3,
    "comment": "ist mir zu bitter",
    "origin": "AT",
    "roastLevel": "medium-dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "28.00",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 11,
    "roaster": "DieRöster - Suchan Palermo",
    "description": "schokoladig nussig holzig",
    "favorite": true,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "15",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2023-03-15T20:48:47.000Z"),
    "cremaRating": 5,
    "tasteRating": 5,
    "tasteNotes": "nutty, woody, chocolate, very low acidity",
    "url": "https://www.dieroester.at/roester/suchan/palermo",
    "imageUrl": "https://www.dieroester.at/media-file/pic/374340/pic/91790140DAB3F97DA71D076723470CA4/Suchan-Palermo.png",
    "comment": "Parade-Espresso für Leute, die viel Aroma und wenig Säure möchten",
    "origin": "IT",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "45.60",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 12,
    "roaster": "Bohnendealer - Amicizia Espresso",
    "description": "schokoladig nussig kräftig samtig",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "18",
    "percentArabica": 26,
    "percentRobusta": 74,
    "cuppingTime": new Date("2023-04-07T18:07:06.000Z"),
    "cremaRating": 3,
    "tasteRating": 3,
    "tasteNotes": "dark chocolate, spicy, full-bodied, velvety, no acidity",
    "url": "https://www.bohnendealer.coffee/collections/coffee/products/amicizia-espresso",
    "imageUrl": "https://www.bohnendealer.coffee/cdn/shop/products/amiciziabybohnendealer_e2334c35-155e-4c18-b0f1-014077a9828a_1200x1200.png?v=1679162019",
    "comment": "Neapolitan dark roast from 7 origins: India, Uganda, Costa Rica, Colombia, El Salvador, Brazil, Ethiopia",
    "origin": "IN,UG,CR,CO,SV,BR,ET",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "31.90",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 13,
    "roaster": "Bohnendealer - Paris",
    "description": "dunkel würzig rassig kräfrig",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "11",
    "percentArabica": 60,
    "percentRobusta": 40,
    "cuppingTime": new Date("2023-04-07T18:17:36.000Z"),
    "cremaRating": 2.5,
    "tasteRating": 2.5,
    "tasteNotes": "dark, spicy, chocolate notes, full body",
    "url": "https://www.bohnendealer.coffee/products/paris-espresso-premium-slow-roast-kaffee",
    "imageUrl": "https://www.bohnendealer.coffee/cdn/shop/products/Parisbybohnendealer_1200x1200.png?v=1679162211",
    "comment": "French roast style, from Ecuador, Ethiopia and India",
    "origin": "EC,ET,IN",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "31.90",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 14,
    "roaster": "Bohnendealer - Malabar",
    "description": "schokoladig nussig mild samtig",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "11",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2023-05-07T07:02:11.000Z"),
    "cremaRating": 1,
    "tasteRating": 1,
    "tasteNotes": "chocolate, nutty, sweet, monsoon processed",
    "url": "https://www.bohnendealer.coffee/products/monsooned-malabar-espresso",
    "imageUrl": "https://www.bohnendealer.coffee/cdn/shop/files/Malabarbybohnendealer_1200x1200.png?v=1683285158",
    "comment": "Monsooned process creates unique flavor",
    "origin": "IN",
    "roastLevel": "medium",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "33.80",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 15,
    "roaster": "Bohnendealer - Siena",
    "description": "dunkel schokoladig kräftig",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "13",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2023-05-14T08:41:28.000Z"),
    "cremaRating": 3,
    "tasteRating": 3,
    "tasteNotes": "dark chocolate, Italian style, traditional",
    "url": "https://www.bohnendealer.coffee/products/siena-espresso",
    "imageUrl": "https://www.bohnendealer.coffee/cdn/shop/products/sienabybohnendealer_1200x1200.png?v=1679162239",
    "comment": "Hommage to Italian coffee culture",
    "origin": "IT",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "31.90",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 16,
    "roaster": "DieRöster - Kaffee vom See",
    "description": "Uganda Indonesien",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "21",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2023-06-08T06:45:36.000Z"),
    "cremaRating": 1,
    "tasteRating": 1,
    "comment": "",
    "origin": "UG,ID",
    "roastLevel": "medium",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "33.30",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 17,
    "roaster": "DieRöster - Suchan Bologna",
    "description": "Leicht fruchtig, schokoladig",
    "favorite": true,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "12",
    "percentArabica": 90,
    "percentRobusta": 10,
    "cuppingTime": new Date("2023-06-10T12:32:49.000Z"),
    "cremaRating": 3,
    "tasteRating": 3,
    "tasteNotes": "light fruity, chocolate, balanced, bitter chocolate notes",
    "url": "https://www.dieroester.at/roester/suchan/bologna",
    "imageUrl": "https://www.dieroester.at/media-file/pic/374333/pic/6D23FB9F141D79881B58EFA7EBCAE6A4/Suchan---Bologna.png",
    "comment": "90/10 Mischung aus Brasilien, Indien, Äthiopien, Nicaragua",
    "origin": "BR,IN,ET,NI",
    "roastLevel": "medium-dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "43.20",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 18,
    "roaster": "220 Grad",
    "description": "Guatemala Single Region Robusta",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "5",
    "percentArabica": 0,
    "percentRobusta": 100,
    "cuppingTime": new Date("2023-08-18T06:14:24.000Z"),
    "cremaRating": 5,
    "tasteRating": 3,
    "tasteNotes": "creamy, sweet grain, hazelnut, walnut, dark caramel, cinnamon, lemongrass",
    "url": "https://www.220grad.com",
    "comment": "Finca Santa Isabel, biodynamic cultivation, 1400m altitude",
    "origin": "GT",
    "roastLevel": "medium-dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "34.20",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 19,
    "roaster": "Lavazza",
    "description": "Espresso Italiano Cremoso",
    "favorite": true,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "9",
    "percentArabica": 30,
    "percentRobusta": 70,
    "cuppingTime": new Date("2023-10-15T10:29:58.000Z"),
    "cremaRating": 5,
    "tasteRating": 5,
    "tasteNotes": "chocolate, spices, cocoa, long-lasting crema",
    "url": "https://www.lavazza.com/en/coffee-beans/espresso-italiano-cremoso",
    "imageUrl": "https://www.lavazza.com/content/dam/lavazza-athena/com/b2c/pdp-pag-prodotto/coffee/hero-product-banner/main-assets-coffee/beans/espresso/2799-m-espresso_cremoso-beans%25402.png",
    "comment": "Röstgrad mittel, Intensity 8/10, from Latin America and Southeast Asia",
    "origin": "LA,AS",
    "roastLevel": "medium",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "16.49",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 20,
    "roaster": "Lavazza",
    "description": "Barista intenso",
    "favorite": true,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "10",
    "percentArabica": 50,
    "percentRobusta": 50,
    "cuppingTime": new Date("2024-01-10T18:03:35.000Z"),
    "cremaRating": 5,
    "tasteRating": 5,
    "tasteNotes": "cocoa, wood, hazelnut, full body, intense aftertaste",
    "url": "https://www.lavazza.com/en/coffee-beans/espresso-barista-intenso",
    "imageUrl": "https://www.lavazza.com/content/dam/lavazza-athena/com/b2c/pdp-pag-prodotto/coffee/hero-product-banner/main-assets-coffee/beans/espresso/2848-m-espresso_barista_intenso-beans%25402.png",
    "comment": "Intensity 9/10, perfect for espresso and moka",
    "origin": "BR,AS",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "19.99",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 22,
    "roaster": "Tchibo",
    "description": "Barista Espresso",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "19",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2024-05-01T08:25:19.000Z"),
    "cremaRating": 2.5,
    "tasteRating": 2.5,
    "tasteNotes": "nutty, golden crema, Brazilian highlands",
    "url": "https://www.tchibo.de/products/280387747392/barista-espresso",
    "imageUrl": "https://www.tchibo.de/img/ggAHTat1/900/image.avif",
    "comment": "Sehr wenig Säure, 100% Fairtrade, drum roasted",
    "origin": "BR",
    "roastLevel": "medium",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "19.99",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 23,
    "roaster": "Tchibo",
    "description": "Barista Espresso Dark",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "10",
    "percentArabica": 70,
    "percentRobusta": 30,
    "cuppingTime": new Date("2024-06-22T09:33:01.000Z"),
    "cremaRating": 3,
    "tasteRating": 3,
    "tasteNotes": "roasted nuts, velvety dark crema, intense",
    "url": "https://www.tchibo.de",
    "comment": "India and Brazil blend, dark roast",
    "origin": "IN,BR",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "22.99",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "id": 24,
    "roaster": "Tchibo",
    "description": "Cafe Crema Barista",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "13",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2024-06-22T09:33:37.000Z"),
    "cremaRating": 3,
    "tasteRating": 3,
    "tasteNotes": "mild, red berries, velvety crema",
    "url": "https://www.tchibo.de",
    "comment": "gut zum verdünnen, geschmacklich fad, gut verträglich, South American beans",
    "origin": "SA",
    "roastLevel": "light",
    "brewingMethod": "espresso",
    "recommendedMethod": "filter",
    "price": "14.99",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Pure espresso",
    "coffeeGroup": ""
  },
  {
    "roaster": "Eduscho",
    "description": "Espresso Intenso",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "1",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cremaRating": 1,
    "tasteRating": 2,
    "tasteNotes": "",
    "url": "",
    "comment": "erdig ist nicht meins",
    "origin": "",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "16.99",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Stretched with hot water (Americano style)",
    "id": 25,
    "cuppingTime": new Date("2025-06-04T12:18:08.000Z"),
    "coffeeGroup": "eduscho-espresso-intenso"
  },
  {
    "roaster": "Eduscho",
    "description": "Espresso Intenso",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "1",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cremaRating": 1,
    "tasteRating": 2,
    "tasteNotes": "Earthy: 4, Roasted: 1",
    "url": "",
    "comment": "",
    "origin": "",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "16.99",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "18g dose stretched to 30 seconds - Americano style - Extra sieve",
    "coffeeGroup": "eduscho-espresso-intenso",
    "id": 1749481555147,
    "cuppingTime": new Date("2025-06-09T15:05:55.147Z")
  },
  {
    "id": 1750367411440,
    "roaster": "Eduscho",
    "description": "Espresso Intenso",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "40",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2025-06-19T19:10:11.440Z"),
    "cremaRating": 0,
    "tasteRating": 5,
    "tasteNotes": "Earthy: 4, Roasted: 1, Caramel: 2",
    "url": "",
    "comment": "",
    "origin": "",
    "roastLevel": "dark",
    "brewingMethod": "coldbrew",
    "recommendedMethod": "espresso",
    "price": "16.99",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Cold brew - 24 hours steep time, very coarse grind",
    "coffeeAmount": "90",
    "servings": "20",
    "coffeeGroup": "eduscho-espresso-intenso"
  },
  {
    "id": 1761153808984,
    "roaster": "Lavazza",
    "description": "\u00a1Tierra! For Africa Ground Coffee",
    "favorite": true,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "20",
    "percentArabica": 90,
    "percentRobusta": 10,
    "cuppingTime": new Date("2025-10-22T11:23:28.984Z"),
    "cremaRating": 5,
    "tasteRating": 5,
    "tasteNotes": "Chocolate: 4, Nutty: 1, Fruity: 2, Floral: 2, Citrus: 1, Caramel: 1, Roasted: 4, Earthy: 1, Spicy: 1, Acidic: 2, Bitter: 3, Sweet: 2",
    "url": "https://www.lavazza.com/en/roast-and-ground-coffee/tierra-africa",
    "imageUrl": "https://www.lavazza.com/content/dam/lavazza-athena/b2c/pdp-pag-prodotto/coffee/hero-product-banner/2-main-asset-coffee/tierra-2023/ground/africa/3324-m-tierra_africa-ground-com-%25402.png",
    "comment": "",
    "origin": "ET (Ethiopia), UG (Uganda), TZ (Tanzania)",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "33.90",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "18g dose stretched to 30 seconds - Americano style",
    "coffeeAmount": "18",
    "coffeeGroup": ""
  },
  {
    "id": 1761155279328,
    "roaster": "Lavazza",
    "description": "Cafe Crema Classico",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "2",
    "percentArabica": 70,
    "percentRobusta": 30,
    "cuppingTime": new Date("2025-10-22T13:47:59.328Z"),
    "cremaRating": 1,
    "tasteRating": 1,
    "tasteNotes": "",
    "url": "https://www.kava.eu/en/p/lavazza-caffe-crema-classico-coffee-beans-1kg",
    "imageUrl": "https://skkavaeu.s14.cdn-upgates.com/_cache/c/b/cbf52a756f0041f092b5f8e22a5a0a19-lavazza-caffe-crema-classico-zrnkova-kava-1kg-1.jpg",
    "comment": "",
    "origin": "",
    "roastLevel": "medium",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "21.80",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "18g dose stretched to 30 seconds - Americano style",
    "coffeeAmount": "18",
    "coffeeGroup": ""
  },
  {
    "id": 1766852409775,
    "roaster": "Lavazza",
    "description": "Gran Crema Barista",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "15",
    "percentArabica": 40,
    "percentRobusta": 60,
    "cuppingTime": new Date("2025-12-27T12:20:09.775Z"),
    "cremaRating": 4,
    "tasteRating": 2,
    "tasteNotes": "Sweet: 3, Roasted: 1, Chocolate: 2, Caramel: 2, Nutty: 2, Bitter: 1",
    "url": "https://www.lavazza.com/en/coffee-beans/espresso-barista-gran-crema",
    "imageUrl": "https://www.lavazza.com/content/dam/lavazza-athena/com/b2c/pdp-pag-prodotto/coffee/hero-product-banner/main-assets-coffee/beans/espresso/2735-m-espresso_barista_gran_crema-beans%25402.png",
    "comment": "Intensity 7/10, smooth medium roast, blend of South American Arabica (40%) and Southeast Asian Robusta (60%). Best for espresso machine or moka pot.",
    "origin": "BR,HN,AS",
    "roastLevel": "medium",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "21",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "18g dose stretched to 30 seconds - Americano style",
    "coffeeAmount": "18",
    "coffeeGroup": ""
  },
  {
    "id": 1766852409776,
    "roaster": "Gorilla",
    "description": "Delicato - Premium Roasted Coffee Beans",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "7",
    "percentArabica": 40,
    "percentRobusta": 60,
    "cuppingTime": new Date("2026-01-23T09:00:00.000Z"),
    "cremaRating": 5,
    "tasteRating": 3,
    "tasteNotes": "Roasted: 2, Bitter: 1, Earthy: 1, Sweet: 3",
    "url": "https://www.kaffee-joerges.de/kaffeesorten/gorilla-espresso-delicato",
    "imageUrl": "https://static.wixstatic.com/media/c0f840_10188ca606e740a684843c772011c8c9~mv2.png/v1/fill/w_1201,h_1621,al_c/231016_Delicato_1000g.png",
    "comment": "Intensität 7/10, Split-Roasting-Verfahren (Trommelröstung), Arabica aus südamerikanischem Hochland, Robusta aus Asien. Kaffeegroßrösterei A. Joerges GmbH seit 19. Jhd., Marke Gorilla seit 2004",
    "origin": "SA,AS",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "18.75",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Siebträger, Vollautomat, Espresso Kanne",
    "coffeeGroup": ""
  },
  {
    "id": 1711929600000,
    "roaster": "Lavazza",
    "description": "Caffè Crema Vibrante (Caffè Art Special Edition)",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "23",
    "percentArabica": 100,
    "percentRobusta": 0,
    "cuppingTime": new Date("2026-04-01T09:00:00.000Z"),
    "cremaRating": 0,
    "tasteRating": 0,
    "tasteNotes": "Chocolate: 3",
    "url": "",
    "imageUrl": "https://m.media-amazon.com/images/I/41is0jN87rL.jpg",
    "comment": "Intensität 5/10, Body: Full, Caffè Art Special Edition. Rund und ausgewogen mit Schokoladennoten. 8-9 Bar Druck bei Mahlgrad 23.",
    "origin": "IT",
    "roastLevel": "medium",
    "brewingMethod": "espresso",
    "recommendedMethod": "caffe-crema",
    "price": "17",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "Ideal für Caffè Crema, Cappuccino & Latte. Mahlgrad 23, ergibt 8-9 Bar.",
    "coffeeGroup": ""
  },
  {
    "id": 1747087624000,
    "roaster": "Caffe Borbone",
    "description": "Miscela Blu Linea Bar",
    "favorite": false,
    "grinded": false,
    "grindingTime": "",
    "grindingDegree": "",
    "percentArabica": 30,
    "percentRobusta": 70,
    "cuppingTime": new Date("2026-05-12T20:07:04.000Z"),
    "cremaRating": 0,
    "tasteRating": 0,
    "tasteNotes": "",
    "url": "https://www.vettore.at/borbone-blu-bar",
    "imageUrl": "/images/borbone-blu-linea-bar-1kg.webp",
    "comment": "Bestellt bei vettore.at am 12.05.2026 (Bestell-Nr. 71397) zu 15,99 €/kg + 5,49 € Versand. Neapolitanischer Linea-Bar-Blend, erwartete Noten: Kakao, Holz, Vanille, Schokolade, leichte Würze. Noch nicht verkostet.",
    "origin": "SA,AS",
    "roastLevel": "dark",
    "brewingMethod": "espresso",
    "recommendedMethod": "espresso",
    "price": "15.99",
    "packageSize": 1000,
    "currency": "EUR",
    "preparationNotes": "",
    "coffeeGroup": ""
  }
];